'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n          @media (max-width: ', 'em) and (min-width: ', 'em) {\n            ', ';\n          }\n        '], ['\n          @media (max-width: ', 'em) and (min-width: ', 'em) {\n            ', ';\n          }\n        ']),
    _templateObject2 = _taggedTemplateLiteral(['\n          @media (max-width: ', 'em) {\n            ', ';\n          }\n        '], ['\n          @media (max-width: ', 'em) {\n            ', ';\n          }\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n          @media (min-width: ', 'em) {\n            ', ';\n          }\n        '], ['\n          @media (min-width: ', 'em) {\n            ', ';\n          }\n        ']);

var _styledComponents = require('styled-components');

var _defaultBreakpoints = require('./defaultBreakpoints');

var _defaultBreakpoints2 = _interopRequireDefault(_defaultBreakpoints);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/*eslint-disable */
// iterate through the sizes and create a media template


var mediaQuery = function mediaQuery(userBreakpoints) {
  var availableBreakpoints = userBreakpoints || _defaultBreakpoints2.default;
  var acumulatedMedia = Object.keys(availableBreakpoints).reduce(function (accumulator, obj) {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    var emSizeMin = availableBreakpoints[obj].min / 16;
    var emSizeMax = availableBreakpoints[obj].max / 16;

    accumulator[obj] = function () {
      if (emSizeMin && emSizeMax) {
        return (0, _styledComponents.css)(_templateObject, emSizeMax, emSizeMin, _styledComponents.css.apply(undefined, arguments));
      } else if (!emSizeMin && emSizeMax) {
        return (0, _styledComponents.css)(_templateObject2, emSizeMax, _styledComponents.css.apply(undefined, arguments));
      } else if (emSizeMin && !emSizeMax) {
        return (0, _styledComponents.css)(_templateObject3, emSizeMin, _styledComponents.css.apply(undefined, arguments));
      }
    };

    return accumulator;
  }, {});
  return acumulatedMedia;
};

exports.default = mediaQuery;